import { Helmet } from "react-helmet-async";

interface SeoProps {
  title: string;
  description: string;
  path: string;
  keywords?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  robots?: string;
  type?: "website" | "article";
  image?: string;
}

const SITE_URL = "https://studie-connect.nl";

const Seo = ({ title, description, path, keywords, jsonLd, robots = "index,follow", type = "website", image }: SeoProps) => {
  const absoluteUrl = `${SITE_URL}${path === "/" ? "" : path}` || SITE_URL;
  const canonical = path === "/" ? `${SITE_URL}/` : absoluteUrl;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="studie connect" />
      <meta property="og:locale" content="nl_NL" />
      {image && <meta property="og:image" content={image} />}


      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      {image && <meta name="twitter:image" content={image} />}

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
